// extracted by mini-css-extract-plugin
export default {"Close":"CloseButton_Close__H6EwF"};